// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: require('../../package.json').version,
  filestack: "AwDLa7vDzR0SS0uYLbWxwz",
  apiUrl: "https://e3qs002zb5.execute-api.us-east-1.amazonaws.com/prod",
  platformID: "izQ2rLBmMf1WnM0wSh24P4GOsaKUKCr34Buhyon6"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
